import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  id: "MyPathContainer",
  class: "myPathContainer"
};
const _hoisted_2 = {
  key: 0,
  class: "visibilityWarningPathSubContainer"
};
const _hoisted_3 = {
  class: "titlePathSubContainer"
};
const _hoisted_4 = {
  class: "pathSubContainer"
};
const _hoisted_5 = {
  class: "pathFlexContainer"
};
const _hoisted_6 = {
  class: "cell"
};
const _hoisted_7 = {
  class: "titleItem"
};
const _hoisted_8 = {
  class: "titleItem"
};
const _hoisted_9 = {
  class: "cell cellFullHeight"
};
const _hoisted_10 = {
  class: "titleItem"
};
const _hoisted_11 = {
  class: "fitContent"
};
const _hoisted_12 = {
  class: "leftButton"
};
const _hoisted_13 = {
  class: "titlePathSubContainer"
};
const _hoisted_14 = {
  class: "pathSubContainer"
};
const _hoisted_15 = {
  class: "pathFlexContainer"
};
const _hoisted_16 = {
  class: "cell"
};
const _hoisted_17 = {
  class: "pathFlexContainer"
};
const _hoisted_18 = {
  class: "singleCell"
};
const _hoisted_19 = {
  class: "titleItem"
};
const _hoisted_20 = {
  class: "listCheckboxes"
};
const _hoisted_21 = {
  class: "addNewCheckboxItem"
};
const _hoisted_22 = {
  class: "pathFlexContainer"
};
const _hoisted_23 = {
  class: "cell"
};
const _hoisted_24 = {
  class: "titleItem"
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  class: "titlePathSubContainer"
};
const _hoisted_27 = {
  key: 1,
  class: "pathSubContainer"
};
const _hoisted_28 = {
  class: "pathFlexContainer"
};
const _hoisted_29 = {
  class: "singleCell"
};
const _hoisted_30 = {
  class: "speachGridAlign"
};
const _hoisted_31 = {
  class: "speachGridAlign"
};
const _hoisted_32 = {
  class: "bottomMenuBar"
};
const _hoisted_33 = {
  class: "publishPathButtonContainer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_alert = _resolveComponent("w-alert");
  const _component_w_input = _resolveComponent("w-input");
  const _component_image_background = _resolveComponent("image-background");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_el_link = _resolveComponent("el-link");
  const _component_w_checkbox_group = _resolveComponent("w-checkbox-group");
  const _component_user_search_compact = _resolveComponent("user-search-compact");
  const _component_w_tag = _resolveComponent("w-tag");
  const _component_SpeachGrid = _resolveComponent("SpeachGrid");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_grid_layout = _resolveComponent("grid-layout");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_affix = _resolveComponent("el-affix");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_ctx.path && _ctx.currentUserUID && !_ctx.isOwnerOfThisPath ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_w_alert, {
    description: _ctx.otherUserTranslatedMessage,
    type: "info",
    showIcon: true,
    closable: false
  }, null, 8, ["description"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('path.edit.detail')), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('path.edit.titleEdit')), 1), _createVNode(_component_w_input, {
    onChangeInput: _cache[0] || (_cache[0] = $event => _ctx.onBlurTitle($event)),
    value: _ctx.title,
    maxlength: "100",
    "show-word-limit": true,
    noPrefix: true
  }, null, 8, ["value"]), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('path.edit.descriptionEdit')), 1), _createVNode(_component_w_input, {
    onChangeInput: _cache[1] || (_cache[1] = $event => _ctx.onBlurDescription($event)),
    value: _ctx.description,
    maxlength: "1000",
    "show-word-limit": true,
    type: "textarea",
    class: "descriptionArea",
    rows: "4"
  }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('path.edit.importImg')), 1), _createElementVNode("div", _hoisted_11, [_createVNode(_component_image_background, {
    idDivBackground: "pathPicture",
    "image-url": _ctx.goodImage,
    width: "274px",
    height: "154px",
    radius: "8px",
    "background-size": "cover"
  }, null, 8, ["image-url"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_standard_button, {
    class: "purpleButton",
    label: _ctx.$t('path.edit.choosePicture'),
    onAction: _ctx.changePicture
  }, null, 8, ["label", "onAction"])])])])]), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('path.edit.assignment')), 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_w_alert, {
    description: _ctx.$t('path.edit.visibilityWarning'),
    type: "info",
    showIcon: true,
    closable: false
  }, null, 8, ["description"])]), _cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "cell"
  }, null, -1))]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('path.edit.group.title')), 1), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_link, {
    href: "/administration/listGroupe",
    icon: _ctx.plus
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('path.edit.group.linktogroup')), 1)]),
    _: 1
  }, 8, ["icon"])]), _createVNode(_component_w_checkbox_group, {
    items: _ctx.groups,
    alreadyCheckedItems: _ctx.checkedGroups,
    valueKey: "id",
    labelKey: "name",
    onCheckedOneItem: _ctx.onChangeOneAssignment
  }, null, 8, ["items", "alreadyCheckedItems", "onCheckedOneItem"])])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('path.edit.user')), 1), _ctx.path ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_user_search_compact, {
    "already-selected-users": _ctx.path.assignment.users,
    onSelectedUsers: _ctx.selectUsers
  }, null, 8, ["already-selected-users", "onSelectedUsers"]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.path.assignment.users, user => {
    return _openBlock(), _createBlock(_component_w_tag, {
      textTag: user.firstName + ' ' + user.lastName,
      key: user.userID,
      round: "",
      onRemoveTag: $event => _ctx.deleteOneUser(user)
    }, null, 8, ["textTag", "onRemoveTag"]);
  }), 128))])])) : _createCommentVNode("", true)]), _cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "cell"
  }, null, -1))])]), _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('path.edit.speaches.title')), 1), _ctx.path ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_grid_layout, null, {
    default: _withCtx(() => [_createVNode(_component_el_tabs, {
      class: "tabs",
      modelValue: _ctx.selectedTab,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.selectedTab = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        name: "SELECTED",
        label: _ctx.$t('path.edit.speaches.selected')
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_ctx.selectedTab === 'SELECTED' ? (_openBlock(), _createBlock(_component_SpeachGrid, {
          key: 0,
          url: `/api/v2/learningPath/${_ctx.pathId}/getSpeaches?selected=true`,
          "load-regulated": true,
          "default-filter-etat": "PUBLIE",
          "publish-filter": false,
          "change-order-filter": false,
          "remove-button": true,
          draggable: true,
          "comments-enabled": "false",
          "is-owner-of-the-list": _ctx.isOwnerOfThisPath,
          onRemoveSpeachFrom: _cache[2] || (_cache[2] = $event => _ctx.removeSpeachFrom($event)),
          onChangeSpeachesOrder: _cache[3] || (_cache[3] = $event => _ctx.changeSpeachesOrder($event))
        }, null, 8, ["url", "is-owner-of-the-list"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_tab_pane, {
        name: "AVAILABLE",
        label: _ctx.$t('path.edit.speaches.available')
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_ctx.selectedTab === 'AVAILABLE' ? (_openBlock(), _createBlock(_component_SpeachGrid, {
          key: 0,
          url: `/api/v2/learningPath/${_ctx.pathId}/getSpeaches?selected=false`,
          "load-regulated": true,
          "default-filter-etat": "PUBLIE",
          "publish-filter": false,
          "add-button": true,
          "filter-by-name": true,
          "comments-enabled": "false",
          onAddSpeachTo: _cache[4] || (_cache[4] = $event => _ctx.addSpeachTo($event))
        }, null, 8, ["url"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["label"])]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  })])])])) : _createCommentVNode("", true)]), _createVNode(_component_el_affix, {
    position: "bottom",
    target: "#MyPathContainer",
    offset: 0
  }, {
    default: _withCtx(() => [_createVNode(_component_el_divider, {
      class: "hrSeparator"
    }), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createVNode(_component_standard_button, {
      label: _ctx.$t('path.edit.publish'),
      onAction: _ctx.publishPath,
      disabled: !_ctx.canPublish
    }, null, 8, ["label", "onAction", "disabled"])])])]),
    _: 1
  })], 64);
}